"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.responseSchema = exports.requestSchema = exports.MAX_DATE_WINDOW_DAYS = exports.MAX_IRRIGATION_ZONE_IDS = exports.MAX_BLOCK_IDS = void 0;
const zod_1 = require("zod");
exports.MAX_BLOCK_IDS = 20000;
exports.MAX_IRRIGATION_ZONE_IDS = 2000;
// Callers ask for at most about 16 days.
exports.MAX_DATE_WINDOW_DAYS = 62;
const DAY_MS = 24 * 60 * 60 * 1000;
// The largest Postgres int4, the type of the id columns these ids are matched against.
const idSchema = zod_1.z.number().int().positive().max(2147483647);
// A day, or a UTC timestamp as the Irrigation Scheduler sends.
const dateSchema = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z)?$/)
    .refine((value) => {
    const [year, month, day] = value.slice(0, 10).split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    return (date.getUTCFullYear() === year &&
        date.getUTCMonth() === month - 1 &&
        date.getUTCDate() === day &&
        !Number.isNaN(Date.parse(value)));
});
exports.requestSchema = zod_1.z
    .object({
    blockIds: zod_1.z.array(idSchema).max(exports.MAX_BLOCK_IDS),
    irrigationZoneIds: zod_1.z.array(idSchema).max(exports.MAX_IRRIGATION_ZONE_IDS),
    dateFrom: dateSchema,
    dateTo: dateSchema,
})
    .refine(({ dateFrom, dateTo }) => Date.parse(dateFrom) <= Date.parse(dateTo), {
    message: 'dateFrom must not be after dateTo',
    path: ['dateFrom'],
})
    .refine(({ dateFrom, dateTo }) => Date.parse(dateTo) - Date.parse(dateFrom) <= exports.MAX_DATE_WINDOW_DAYS * DAY_MS, {
    message: `dateTo must not be more than ${exports.MAX_DATE_WINDOW_DAYS} days after dateFrom`,
    path: ['dateTo'],
});
const timeseriesPointSchema = zod_1.z.object({
    timestamp: zod_1.z.string(),
    value: zod_1.z.union([zod_1.z.number(), zod_1.z.string(), zod_1.z.null()]),
});
const blockWithETDataSchema = zod_1.z.object({
    block_ids: zod_1.z.array(zod_1.z.number()),
    kc: zod_1.z.array(timeseriesPointSchema),
    etc: zod_1.z.array(timeseriesPointSchema),
    rain: zod_1.z.array(timeseriesPointSchema),
});
const zoneWithETDataArraySchema = zod_1.z.object({
    zone_id: zod_1.z.number(),
    blockData: blockWithETDataSchema,
});
exports.responseSchema = zod_1.z.object({
    dailyEt: zod_1.z.array(zoneWithETDataArraySchema),
});
exports.path = '/irrigation-scheduler/planning-data';
//# sourceMappingURL=index.js.map